export default __webpack_public_path__ + "static/media/kitchen4-afterD-1440w.0d5a90f8.png";